declare var require: any;
import { Component, OnInit,AfterViewInit, OnDestroy, HostListener, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from './../../services/auth.service';
import { Router } from '@angular/router';
import { LoggingService } from '../../services/logging.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare var $: any;
import Swal from 'sweetalert2';
import * as moment from 'moment';
var moments = require('moment-timezone');
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgZone } from '@angular/core';

@Component({
  selector: 'app-message',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './message.component.html',
  styleUrls: ['../../../assets/css/min-bootstrap.min.css','../../../assets/css/font-awesome.min.css','../../../assets/css/chat.css','./message.component.css']
})
export class MessageComponent implements OnInit,AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  editID: any;
  messages: any[];
  message: string = '';
  repMessage: string = '';
  friendsList: any;
  selectedFriendName: any;
  selectedFriendId: any;
  loading: boolean = false;
  UserId: any;
  UserName: any;
  FrndId: any;
  isEmojiPickerVisible: boolean;
  repisEmojiPickerVisible: boolean;
  fileName: any;
  config : any;
  file: File = null;
  adminId : any;
  msgType : any;
  sessID : any;
  adminReq : any[];
  chathide : any;
  endsession : any;
  adminnotconnect : any;
  endsess : any;
  convertbtn_id : any;
  aid : any;
  EnbleSerch:boolean=false
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  snoozedataobj:any={}
  enablesnooze:boolean=false
  selectedFriend: any;
  snoozeTouched: boolean = false;
  isSending: boolean = false;
  showScrollToBottom: boolean = false;
  isChatSearchVisible: boolean = false;
  chatSearchQuery: string = '';
  selectedFile: File = null;
  isCutoffTime: boolean = false;
  pendingActionFriendId: any;
  @ViewChild('selctedsnoozeata') snoozeInput: ElementRef;
  private sendRetryCount: number = 0;
  private readonly MAX_SEND_RETRIES = 1;
  private getMessagesRetryCount: number = 0;
  private readonly MAX_GET_RETRIES = 1;
  constructor(private _api: ApiService, public _auth: AuthService, private _router: Router, private idle: Idle, private keepalive: Keepalive, private spinner: NgxSpinnerService, private zone: NgZone, private _log: LoggingService) {
    this._api.getTypeRequest('user/getsettings').subscribe((res: any) => {
      try {
        if (res && res.data && res.data[0]) {
          idle.setIdle(res.data[0].idletime);
        }
      } catch (e) {}
    });
  }

  showSnoozeLastDayOption: boolean = false;
selectedSnoozedate:any
showSnoozeList = false;

  toggleSnoozeListView() {
    this.showSnoozeList = !this.showSnoozeList;
    if(this.showSnoozeList){
      $('.showSnoozeList').show()
      $('#userlistview').addClass('userlistview')
    }else{
      $('.showSnoozeList').hide()
      $('#userlistview').removeClass('userlistview')
    }
  }
  getPSTTime() {
    //var options = { timeZone:'America/Los_Angeles',hour12: false};
    let date1 = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles"
    });
    return date1
  }
  snoozepickeddatetime:any=''
  submitpck(){
    if (!this.snoozepickeddatetime) {
      this.snoozeTouched = true;
      return;
    }
    $('.DatepickerModel').hide();
    this.selectedSnoozedate = moment($('#selctedsnoozeata').val()).format('YYYY-MM-DD HH:mm:ss');
    this.snoozepickeddatetime=''
    this.snoozeTouched = false;
    this.confirmsnoozeyes();
  }
  cancelpick(){
    $('.DatepickerModel').hide();
    this.snoozepickeddatetime=''
  }
  GetSnoozedateoption(day){
    const currentMoment = moment();
    if(day=='later'){
    let date  = moment().set({
        hour: 15,
        minute: 0,
        second: 0,
        millisecond: 0
      }).format('YYYY-MM-DD HH:mm:ss');
      return this.DateFormat(date)
    }else{
    let date = moment(currentMoment).add(1, 'day').set({
        hour: 8,
        minute: 30,
        second: 0,
        millisecond: 0
      }).format('YYYY-MM-DD HH:mm:ss');
      return this.DateFormat(date)
    }
    
  }
  DateFormat(date){
    return moment(date).format("MM/DD/YYYY hh:mm ")
    }
    settingsVal:any
    isOpenDayfordatepicker = (date) => {
      const now = moments(date).tz(this.settingsVal.timezone);
      var daySplit = this.settingsVal.offdays.split(",");
      //log(daySplit.indexOf(now.format('ddd')) !== -1) 
      return daySplit.indexOf(now.format('ddd')) !== -1;
    }
snoozeChat(option: string) {
  const currentmoments = moment();

  if (option === 'pickdatetime') {
    $('.DatepickerModel').show();

      
    $('#selctedsnoozeata').datetimepicker({
      dayOfWeekStart: 1,
      lang: 'en',
      minDate: this.getPSTTime(),
      step: 5,
      format: 'm/d/Y H:i',
      formatDate: 'm/d/Y',
      formatTime: 'H:i',
      minTime: new Date(this.getPSTTime()),
      beforeShowDay: (date) => {
        const isOpenDay = this.isOpenDayfordatepicker(date);
        var isDisabled = isOpenDay;
        return [!isDisabled, ''];
      },
      onChangeDateTime: (ct, $input) => {
        this.zone.run(() => {
          this.snoozepickeddatetime = $input.val();
        });
      }
    });
      setTimeout(() => {
        this.snoozeInput.nativeElement.focus();
      }, 0);
  } else if (option === 'latertoday') {
    // Set selectedSnoozedate to today at 10 am (PST)
    this.selectedSnoozedate = moment().set({
      hour: 15,
      minute: 0,
      second: 0,
      millisecond: 0
    }).format('YYYY-MM-DD HH:mm:ss');
    this.confirmsnoozeyes();
  } else if (option === 'tomorrow') {
    // Set selectedSnoozedate to tomorrow at 10 am (PST)
    this.selectedSnoozedate = moment(currentmoments).add(1, 'day').set({
      hour: 8,
      minute: 30,
      second: 0,
      millisecond: 0
    }).format('YYYY-MM-DD HH:mm:ss');
    this.confirmsnoozeyes();
  } else {
    // Handle other options (if needed)
  }
 
}
  confirmsnoozeno(){
    $('.DatepickerModel').hide();
    $('.confirmsnooze').hide();
    this.selectedSnoozedate =''
    this.snoozepickeddatetime = ''
    this.snoozeTouched = false;
  }
confirmRemoveSnooze(){
  $('.confirmRemoveSnooze').show();
}
confirmRemoveSnoozeyes(){
  $('.confirmRemoveSnooze').hide();
  this.spinner.show();
  let data = { touserid: this.FrndId, userid: this.UserId };
  this._log.log(this.UserId, 'Customer', 'DELETE_SNOOZE', `DeleteSnooze START | userId=${this.UserId} touserid=${this.FrndId}`, 'start', { touserid: this.FrndId });
  this._api.postTypeRequest('messages/DeleteSnooze', data).subscribe((res: any) => {
    this.spinner.hide();
    if (res.status == 1) {
      this._log.log(this.UserId, 'Customer', 'DELETE_SNOOZE', `Snooze deleted | userId=${this.UserId} touserid=${this.FrndId}`, 'success', { touserid: this.FrndId });
      this._api.postTypeRequest('snooze-alert', { userid: this.UserId }).subscribe((res: any) => {});
      this.snoozedataobj = {};
      this.GetSnoozeData();
    } else {
      this._log.log(this.UserId, 'Customer', 'DELETE_SNOOZE', `DeleteSnooze returned status=0 | userId=${this.UserId}`, 'error', { touserid: this.FrndId });
    }
  }, err => {
    this.spinner.hide();
    this._log.log(this.UserId, 'Customer', 'DELETE_SNOOZE', `DeleteSnooze HTTP error | userId=${this.UserId}`, 'error', { error: (err && err.message) });
  });
}
confirmRemoveSnoozeno(){
  $('.confirmRemoveSnooze').hide();
}

confirmsnoozeyes(){
  $('.confirmsnooze').hide();
  this.spinner.show();
  let data = { touserid: this.FrndId, snoozeDate: this.selectedSnoozedate, userid: this.UserId };
  this._log.log(this.UserId, 'Customer', 'INSERT_SNOOZE', `InsertSnooze START | userId=${this.UserId} touserid=${this.FrndId} snoozeDate=${this.selectedSnoozedate}`, 'start', { touserid: this.FrndId, snoozeDate: this.selectedSnoozedate });
  this._api.postTypeRequest('messages/InsertSnooze', data).subscribe((res: any) => {
    this.spinner.hide();
    if (res.status == 1) {
      this._log.log(this.UserId, 'Customer', 'INSERT_SNOOZE', `Snooze inserted | userId=${this.UserId} touserid=${this.FrndId}`, 'success', { touserid: this.FrndId, snoozeDate: this.selectedSnoozedate });
      this._api.postTypeRequest('snooze-alert', { userid: this.UserId }).subscribe((res: any) => {});
      this.GetSnoozeData();
    } else {
      this._log.log(this.UserId, 'Customer', 'INSERT_SNOOZE', `InsertSnooze returned status=0 | userId=${this.UserId}`, 'error', { touserid: this.FrndId });
    }
  }, err => {
    this._log.log(this.UserId, 'Customer', 'INSERT_SNOOZE', `InsertSnooze HTTP error | userId=${this.UserId}`, 'error', { error: (err && err.message) });
    this.spinner.hide();
  });
}


 
updateShowSnoozeLastDayOption() {
  const currentTime = new Date().toLocaleString("en-US", {
    timeZone: "America/Los_Angeles"
  });
 
  const currentHour = new Date(currentTime).getHours();
  this.showSnoozeLastDayOption = currentHour < 12;
}

GetSnoozeData(){
  this.spinner.show();
  let data = { type: 2, userid: this.UserId, touserid: this.FrndId };
  this._log.log(this.UserId, 'Customer', 'GET_SNOOZE_DATA', `GetSnoozeData START | userId=${this.UserId} touserid=${this.FrndId}`, 'start', { touserid: this.FrndId });
  this._api.postTypeRequest('messages/GetSnoozeData', data).subscribe((res: any) => {
    this.spinner.hide();
    if (res.status == 1) {
      this._log.log(this.UserId, 'Customer', 'GET_SNOOZE_DATA', `Snooze data fetched | userId=${this.UserId} touserid=${this.FrndId}`, 'success', { touserid: this.FrndId, count: res.data ? res.data.length : 0 });
      if (res.data.length && this.FrndId) {
        this.snoozedataobj = res.data[0];
      } else {
        this.snoozedataobj = {};
      }
    } else {
      this._log.log(this.UserId, 'Customer', 'GET_SNOOZE_DATA', `GetSnoozeData returned status=0 | userId=${this.UserId}`, 'error', { touserid: this.FrndId });
      this.snoozedataobj = {};
    }
  }, err => {
    this.spinner.hide();
    this.snoozedataobj = {};
    this._log.log(this.UserId, 'Customer', 'GET_SNOOZE_DATA', `GetSnoozeData HTTP error | userId=${this.UserId}`, 'error', { error: (err && err.message) });
  });
}
isPSTDaylightSavingTime(): boolean {
  const currentTime = new Date();
  const currentMonth = currentTime.getMonth() + 1;
  return currentMonth >= 3 && currentMonth <= 11;
}
  

  ngAfterViewInit(){
   
    // $('#snoozeDropdownMenu').on('click', this.toggleDropdown);
    // $(document).on('click', this.closeDropdown);
     this.idle.setTimeout(20);
     this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
 
     this.idle.onIdleEnd.pipe(takeUntil(this.destroy$)).subscribe(() => { 
       this.idleState = 'No longer idle.'
       this.reset();
     });
     
     this.idle.onTimeout.pipe(takeUntil(this.destroy$)).subscribe(() => {
       $('#idlemodel').show();
       this.idleState = 'Timed out!';
       this.timedOut = true;      
       this.endChat();
     });
     this.idle.onIdleStart.pipe(takeUntil(this.destroy$)).subscribe(() => {
         this.idleState = 'You\'ve gone idle!'       
         $('#idlemodel').show();
     });   
     this.idle.onTimeoutWarning.pipe(takeUntil(this.destroy$)).subscribe((countdown) => {
       this.idleState = 'You will be logged out in ' + countdown + ' seconds!'
     });
     this.keepalive.interval(15);
     this.keepalive.onPing.pipe(takeUntil(this.destroy$)).subscribe(() => this.lastPing = new Date());
       if (sessionStorage.getItem('sessionid')) {
         this.idle.watch()
         this.timedOut = false;
       } else {
        this.idle.stop();
       }

   
    
    
     window.addEventListener('message',(event) => {
      // Phase-1 guard: skip all socket-driven calls until UserId is resolved
      if (!this.UserId || isNaN(Number(this.UserId)) || Number(this.UserId) <= 0) {
        console.warn('[postMessage] Ignored — UserId not yet set:', this.UserId);
        return;
      }
      if(this._api.WhitelistDomainForpostmessage.indexOf(event.origin)>-1){
        if(event.data?event.data.from=='user':false){
          this.handleMessage();
          // this.refreshFriendData();
        }else if(event.data?event.data.from=='Customer':false){
          this.handleMessage();
          // this.refreshFriendData();
        }
      }
    })
  }
  reset() {
    this.idle.watch();
    this.timedOut = false;
  }
  getLocation(href) {
    var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    }
  }
  stay() {
    $('#idlemodel').hide();
    this.reset();
  }
  idleLogout() {
    this.endChat()
  }
  SessUserData:any =[]
  async ngOnInit() {
    this.isCutoffTime = sessionStorage.getItem('isCutoffTime') === 'true';
    this.updateShowSnoozeLastDayOption()
    var url = (window.location != window.parent.location) ? document.referrer : document.location;
    var host = '';
    if(url && url!=null && typeof url=='string'){
      let location = this.getLocation(url);
      host=location.host?location.host:'';
     }
     if(this._api.HideSearchIconFor.indexOf(host)>-1){
      this.EnbleSerch=false
     }else{
       this.EnbleSerch=true
     }
    var scriptUrl = this._api.baseUrl+'socketwindow';
    let node = document.createElement('iframe');
    node.src = scriptUrl;
    node.className = "d-none";
    this.chathide = 1;
    this.aid = 0;
    this.adminnotconnect = 0;
      this.endsess = 1;
    this.convertbtn_id = sessionStorage.getItem('sessionid')?sessionStorage.getItem('sessionid'):0;
    this.endsession = false;
    document.getElementById('chat-windowTag').appendChild(node);
    var SessUserData = this._auth.getUserDetails();
    this.SessUserData =SessUserData
    // console.log(SessUserData)
    var sessUser = SessUserData[0];
    this.UserId = sessUser.id;
    this.msgType = this._auth.getUsertype() == 'Admin'?0:1;
    if(sessUser.aid){
      this.sessID = this._auth.getUsertype() == 'Admin'?sessUser.id:sessUser.aid;
      this.FrndId = sessUser.aid;
      this.aid = sessUser.aid;
      if(!this.FrndId){
       await this.getFrndId(this.UserId)
      }
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `ngOnInit message/users START | FrndId=${this.FrndId}`, 'start');
      this._api.getTypeRequest('message/users/'+this.FrndId).subscribe((res:any) => {
        var data = this._api.decrypt(res.data);
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `ngOnInit message/users SUCCESS | FrndId=${this.FrndId}`, 'success');
        this.selectFriendToChat(data[0]); 
      }, err => {
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `ngOnInit message/users ERROR | FrndId=${this.FrndId}`, 'error', { error: (err && err.message) });
      });
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `ngOnInit message/adminids START | sessID=${this.sessID}`, 'start');
      this._api.getTypeRequest('message/adminids/'+this.sessID).subscribe((res:any) => {
        this.adminId = res.data[0].aid;
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `ngOnInit message/adminids SUCCESS | sessID=${this.sessID} adminId=${this.adminId}`, 'success');
      }, err => {
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `ngOnInit message/adminids ERROR | sessID=${this.sessID}`, 'error', { error: (err && err.message) });
      });
      if(this._auth.getUsertype()=='admin'){
      this.GetSnoozeData()
      }
    this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `ngOnInit customeradminsession START | FrndId=${this.FrndId}`, 'start');
    this._api.getTypeRequest('user/customeradminsession/'+this.UserId+'/'+this.FrndId).subscribe((res: any) => {
      var settingsVal = this._api.decrypt(res.settings)[0];
       this.settingsVal = this._api.decrypt(res.settings)[0];
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `ngOnInit customeradminsession SUCCESS | FrndId=${this.FrndId}`, 'success');
      var openTime = this.isOpen(settingsVal.starttime, settingsVal.endtime, settingsVal.timezone);
      var openDay = this.isOpenDay(settingsVal.offdays, settingsVal.timezone);
      console.log(openTime,openDay,"openTime,openDay")
       if(openTime && !openDay){
        this.enablesnooze=true
       }else{
        this.enablesnooze=false
       }
     }, err => {
       this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `ngOnInit customeradminsession ERROR | FrndId=${this.FrndId}`, 'error', { error: (err && err.message) });
     })
    } else {
      if(!sessionStorage.getItem('sessionid')){
        this.FrndId = 0;
        this.selectedFriendName = 'Message Us';
        this.selectedFriendId = 0;
      }
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `ngOnInit message/adminids/0 START`, 'start');
      this._api.getTypeRequest('message/adminids/0').subscribe((res:any) => {
        this.adminId = res.data[0].aid;
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `ngOnInit message/adminids/0 SUCCESS | adminId=${this.adminId}`, 'success');
      }, err => {
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `ngOnInit message/adminids/0 ERROR`, 'error', { error: (err && err.message) });
      });
      if(this.msgType == 1){
        this.getMessages(this.UserId);
        this.handleMessage();
      }else{
        if (this.UserId && !isNaN(Number(this.UserId)) && Number(this.UserId) > 0) {
          this.getRespond(this.UserId);
        }
      }
    }
    
  }
  async AfterChatend(){
    var scriptUrl = this._api.baseUrl+'socketwindow';
    let node = document.createElement('iframe');
    node.src = scriptUrl;
    node.className = "d-none";
    this.chathide = 1;
    this.aid = 0;
    this.adminnotconnect = 0;
      this.endsess =0;
      this.scrollToBottom();
    this.convertbtn_id = sessionStorage.getItem('sessionid')?sessionStorage.getItem('sessionid'):0;
    var SessUserData = this._auth.getUserDetails();
    var sessUser = SessUserData[0];
    this.UserId = sessUser.id;
    this.msgType = this._auth.getUsertype() == 'Admin'?0:1;
    if(sessUser.aid){
      this.sessID = this._auth.getUsertype() == 'Admin'?sessUser.id:sessUser.aid;
      this.messages = [];
      this.FrndId = sessUser.aid;
      this.aid = sessUser.aid;
      if(!this.FrndId){
        await this.getFrndId(this.UserId)
       }
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `AfterChatend message/users START | FrndId=${this.FrndId}`, 'start');
      this._api.getTypeRequest('message/users/'+this.FrndId).subscribe((res:any) => {
        var data = this._api.decrypt(res.data);
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `AfterChatend message/users SUCCESS | FrndId=${this.FrndId}`, 'success');
        this.selectFriendToChat(data[0]); 
      }, err => {
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `AfterChatend message/users ERROR | FrndId=${this.FrndId}`, 'error', { error: (err && err.message) });
      });
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `AfterChatend message/adminids START | sessID=${this.sessID}`, 'start');
      this._api.getTypeRequest('message/adminids/'+this.sessID).subscribe((res:any) => {
        this.adminId = res.data[0].aid;
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `AfterChatend message/adminids SUCCESS | sessID=${this.sessID} adminId=${this.adminId}`, 'success');
      }, err => {
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `AfterChatend message/adminids ERROR | sessID=${this.sessID}`, 'error', { error: (err && err.message) });
      });
    } else {
      if(!sessionStorage.getItem('sessionid')){
        this.FrndId = 0;
        this.selectedFriendName = 'Message Us';
        this.selectedFriendId = 0;
      }
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `AfterChatend message/adminids/0 START`, 'start');
      this._api.getTypeRequest('message/adminids/0').subscribe((res:any) => {
        this.adminId = res.data[0].aid;
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `AfterChatend message/adminids/0 SUCCESS | adminId=${this.adminId}`, 'success');
      }, err => {
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_IDS', `AfterChatend message/adminids/0 ERROR`, 'error', { error: (err && err.message) });
      });
      if(this.msgType == 1){
        this.getMessages(this.UserId);
        this._api.postTypeRequest('sendmessage', '').subscribe((res: any) => {(res)});
      }else{
        if (this.UserId && !isNaN(Number(this.UserId)) && Number(this.UserId) > 0) {
          this.getRespond(this.UserId);
        }
      }
    }
  }
  getFrndId(UserId){
    return new Promise(resolve=>{
      this._log.log(UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CONVERSATION', `getFrndId message/conversation START | userId=${UserId}`, 'start');
      this._api.getTypeRequest('message/conversation/'+UserId).subscribe((res:any) => {
        this._log.log(UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CONVERSATION', `getFrndId message/conversation SUCCESS | userId=${UserId}`, 'success');
        var dataval = res.data[0];
        if(res.data && res.data.length >0 && dataval.rid > 0){
          this.FrndId = this.UserId == dataval.sid?dataval.rid:dataval.sid;
          resolve('')
        }else{
          resolve('')
        }
      },err=>{
        this._log.log(UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CONVERSATION', `getFrndId message/conversation ERROR | userId=${UserId}`, 'error', { error: (err && err.message) });
        resolve('')
      })
    })
   
  }
  async handleMessage() {
    console.log('[handleMessage] ▶ START | UserId:', this.UserId, '| FrndId:', this.FrndId, '| msgType:', this.msgType, '| aid:', this.aid);

    if(this.msgType == 1 && !this.FrndId){
      console.log('[handleMessage] Branch: msgType==1 && !FrndId → fetching conversation for UserId:', this.UserId);
      this._log.log(this.UserId, 'Customer', 'GET_CONVERSATION', `handleMessage message/conversation START | userId=${this.UserId}`, 'start');
      this._api.getTypeRequest('message/conversation/'+this.UserId).subscribe((res:any) => {
        this._log.log(this.UserId, 'Customer', 'GET_CONVERSATION', `handleMessage message/conversation SUCCESS | userId=${this.UserId}`, 'success');
        console.log('[handleMessage] conversation API response:', res);
        var dataval = res.data[0];
        console.log('[handleMessage] dataval:', dataval);

        if(res.data && res.data.length >0 && dataval.rid > 0){
          console.log('[handleMessage] Existing conversation found | sid:', dataval.sid, '| rid:', dataval.rid);
          this.FrndId = this.UserId == dataval.sid?dataval.rid:dataval.sid;
          console.log('[handleMessage] Resolved FrndId:', this.FrndId);
          this.getMessages(this.UserId);
          this._auth.setDataInLocalStorage('sessionid', dataval.id);
          this.idle.watch()
          this.timedOut = false;
          this._log.log(this.UserId, 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `handleMessage customeradminsession START | FrndId=${this.FrndId}`, 'start');
          this._api.getTypeRequest('user/customeradminsession/'+this.UserId+'/'+this.FrndId).subscribe((result: any) => {
            this._log.log(this.UserId, 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `handleMessage customeradminsession SUCCESS | FrndId=${this.FrndId}`, 'success');
            console.log('[handleMessage] customeradminsession result:', result);
            var settingsVal = this._api.decrypt(result.settings)[0];
            var openTime = this.isOpen(settingsVal.starttime, settingsVal.endtime, settingsVal.timezone);
            var openDay = this.isOpenDay(settingsVal.offdays, settingsVal.timezone);
            console.log('[handleMessage] settingsVal:', settingsVal, '| openTime:', openTime, '| openDay:', openDay);
            this.aid = 1;
            if(openTime && !openDay){
              console.log('[handleMessage] Chat is open → storing session data');
              this._auth.setDataInLocalStorage('userData', result.data);  
              this._auth.setDataInLocalStorage('token', result.token);    
              this._auth.setDataInLocalStorage('userType', 'User');    
              this._auth.setDataInLocalStorage('timezone', this._api.encryptString(settingsVal.timezone)); 
            } else {
              console.warn('[handleMessage] Chat is CLOSED | openTime:', openTime, '| openDay (is off-day):', openDay);
            }
          }, err => {
            this._log.log(this.UserId, 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `handleMessage customeradminsession ERROR | FrndId=${this.FrndId}`, 'error', { error: (err && err.message) });
          });
        } else if(this.FrndId){
          console.log('[handleMessage] No rid>0 but FrndId exists:', this.FrndId, '→ getMessages');
          this.getMessages(this.UserId);
        } else {
          console.warn('[handleMessage] No conversation data and no FrndId — nothing to load');
        }
      }, err => {
        this._log.log(this.UserId, 'Customer', 'GET_CONVERSATION', `handleMessage message/conversation ERROR | userId=${this.UserId}`, 'error', { error: (err && err.message) });
      });
    } 

    if(this._auth.getUserDetails()){
      var SessUserData = this._auth.getUserDetails();
      var sessUser = SessUserData[0];
      console.log('[handleMessage] Logged-in user found | sessUser:', sessUser);
      this.UserId = sessUser.id;
      this.msgType = this._auth.getUsertype() == 'Admin'?0:1;
      console.log('[handleMessage] Resolved | UserId:', this.UserId, '| msgType:', this.msgType, '| userType:', this._auth.getUsertype());

      if(this.aid){
        console.log('[handleMessage] aid is set → entering admin/session branch');
        this.chathide = 1;
        this.adminReq = [];
        this.sessID = this._auth.getUsertype() == 'Admin'?sessUser.id:sessUser.aid;
        this.FrndId = sessUser.aid;
        console.log('[handleMessage] sessID:', this.sessID, '| FrndId from sessUser.aid:', this.FrndId);

        if(!this.FrndId){
          console.log('[handleMessage] FrndId not set → calling getFrndId for UserId:', this.UserId);
          await this.getFrndId(this.UserId);
          console.log('[handleMessage] getFrndId resolved | FrndId now:', this.FrndId);
        }

        if(!this.FrndId){
          console.warn('[handleMessage] FrndId still undefined after getFrndId — session cleared after end chat. Resetting stale state.');
          // Reset all stale session state so next call to handleMessage starts clean
          this.aid = 0;
          this.FrndId = null;
          this.chathide = 0;
          this.endsess = 0;
          this.convertbtn_id = 0;
          return;
        }

        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `handleMessage message/users START | FrndId=${this.FrndId}`, 'start');
        this._api.getTypeRequest('message/users/'+this.FrndId).subscribe((res:any) => {
          this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `handleMessage message/users SUCCESS | FrndId=${this.FrndId}`, 'success');
          try {
            var data = this._api.decrypt(res.data);
            console.log('[handleMessage] message/users response | data:', data);
            this.selectFriendToChat(data[0]);

            if(this.msgType == 1 && sessionStorage.getItem('sessionid')){
              console.log('[handleMessage] msgType==1 + sessionid → getRespondUser(', this.UserId, ')');
              this.getRespondUser(this.UserId);
            }
            if(this.msgType == 0 && sessionStorage.getItem('sessionid')){
              console.log('[handleMessage] msgType==0 + sessionid → getRespond(', this.FrndId, ')');
              this.getRespond(this.FrndId);
            }
          } catch(e) {
            console.error('[handleMessage] Failed to decrypt message/users response (res.data may be empty):', e.message, '| raw res:', res);
          }
        }, err => {
          this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_USER', `handleMessage message/users ERROR | FrndId=${this.FrndId}`, 'error', { error: (err && err.message) });
        });

      } else {
        console.log('[handleMessage] aid not set | msgType:', this.msgType, '| FrndId:', this.FrndId);
        if(this.msgType == 0 && !this.FrndId){
          console.log('[handleMessage] Admin with no FrndId → getRespond(', this.UserId, ')');
          this.getRespond(this.UserId);
        }
      }
    } else {
      console.warn('[handleMessage] No logged-in user (getUserDetails returned falsy)');
      if(this.msgType == 0 && !this.FrndId){
        console.log('[handleMessage] Fallback → getRespond(', this.UserId, ')');
        this.getRespond(this.UserId);
      }
    }

    this.convertbtn_id = sessionStorage.getItem('sessionid')?sessionStorage.getItem('sessionid'):0;
    if(sessionStorage.getItem('sessionid')){
      this.endsess = sessionStorage.getItem('sessionid');
    }
    console.log('[handleMessage] ■ END | convertbtn_id:', this.convertbtn_id, '| endsess:', this.endsess);
  }

isOpen = (openTime, closeTime, timezone) => {
  const now = moments().tz(timezone);
  const storeOpenTime = moments.tz(now.format('YYYY-mm-dd')+' '+openTime, "YYYY-mm-dd H:mm:ss", timezone);
  const storeCloseTime = moments.tz(now.format('YYYY-mm-dd')+' '+closeTime, "YYYY-mm-dd H:mm:ss", timezone);
  return now.isBetween(storeOpenTime, storeCloseTime);
}
isOpenDay = (days, timezone) => {
  const now = moments().tz(timezone);
  var daySplit = days.split(",");
  return daySplit.indexOf(now.format('ddd')) !== -1;
}
getRespondUser(id){
  this._log.log(id, this.msgType == 0 ? 'Admin' : 'Customer', 'CHECK_USR_CONVERT', `getRespondUser checkusrconvert START | id=${id}`, 'start');
  this._api.getTypeRequest('message/checkusrconvert/'+id).subscribe((res:any) => {
    this._log.log(id, this.msgType == 0 ? 'Admin' : 'Customer', 'CHECK_USR_CONVERT', `getRespondUser checkusrconvert SUCCESS | id=${id}`, 'success');
    var data = res.data;
    if(data.length == 0){
      this.endChat();
    }
  }, err => {
    this._log.log(id, this.msgType == 0 ? 'Admin' : 'Customer', 'CHECK_USR_CONVERT', `getRespondUser checkusrconvert ERROR | id=${id}`, 'error', { error: (err && err.message) });
  });
}
getRespond(id: any){
  if (!id || id === 'undefined' || isNaN(Number(id)) || Number(id) <= 0) {
    return;
  }
  this._log.log(id, this.msgType == 0 ? 'Admin' : 'Customer', 'CHECK_MESSAGES', `getRespond checkmessages START | id=${id}`, 'start');
  this._api.getTypeRequest('message/checkmessages/'+id).subscribe((res:any) => {
    this._log.log(id, this.msgType == 0 ? 'Admin' : 'Customer', 'CHECK_MESSAGES', `getRespond checkmessages SUCCESS | id=${id}`, 'success');
    var data = res.data;
    if(data.length == 0){
      this.getMessages(this.UserId);
      this.endChat();
    } else {
      if(!sessionStorage.getItem('sessionid'))
        this.acceptChat(0,this.FrndId);
    }
  }, err => {
    this._log.log(id, this.msgType == 0 ? 'Admin' : 'Customer', 'CHECK_MESSAGES', `getRespond checkmessages ERROR | id=${id}`, 'error', { error: (err && err.message) });
  });
}
acceptChat(id,fid){
  this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'ACCEPT_CHAT', `acceptChat acceptchat START | fid=${fid} userId=${this.UserId} id=${id}`, 'start', { fid, id });
  this._api.getTypeRequest('message/acceptchat/'+fid+'/'+this.UserId+'/'+id).subscribe(async (res:any) => {
    this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'ACCEPT_CHAT', `acceptChat acceptchat SUCCESS | fid=${fid}`, 'success', { fid });
    if(res.data.length > 0){
       sessionStorage.clear();
       this.FrndId = fid;  
       if(!this.FrndId){
        await this.getFrndId(this.UserId)
       }
       this._auth.setDataInLocalStorage('sessionid', res.data[0].id);  
       this.idle.watch()
       this.timedOut = false;
       this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_CUSTOMER_SESSION', `acceptChat admincustomersession START | fid=${fid} userId=${this.UserId}`, 'start', { fid });
       this._api.getTypeRequest('user/admincustomersession/'+fid+'/'+this.UserId).subscribe((res: any) => {
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_CUSTOMER_SESSION', `acceptChat admincustomersession SUCCESS | fid=${fid}`, 'success', { fid });
        var settingsVal = this._api.decrypt(res.settings)[0];
        var openTime = this.isOpen(settingsVal.starttime, settingsVal.endtime, settingsVal.timezone);
        var openDay = this.isOpenDay(settingsVal.offdays, settingsVal.timezone);
        var url = (window.location != window.parent.location) ? document.referrer : document.location;
        var host = '';
        let showalert=true
        if(url && url!=null && typeof url=='string'){
          let location = this.getLocation(url);
          host=location.host?location.host:'';
         }
         if(this._api.HideSearchIconFor.indexOf(host)>-1){
          showalert=false
         }
        if((openTime && !openDay)||showalert){
          this._auth.setDataInLocalStorage('userData', res.data);  
          this._auth.setDataInLocalStorage('token', res.token);
          this._auth.setDataInLocalStorage('customeradmin', true); 
          this._auth.setDataInLocalStorage('userType', 'Admin');    
          this._auth.setDataInLocalStorage('timezone', this._api.encryptString(settingsVal.timezone)); 
          this._api.postTypeRequest('sendmessage', '').subscribe((res: any) => {(res)});
        } else{
          this._auth.setDataInLocalStorage('cutofEmail', settingsVal.email);  
          this._router.navigate(['/cutoftime']);
        }
       }, err => {
         this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_ADMIN_CUSTOMER_SESSION', `acceptChat admincustomersession ERROR | fid=${fid}`, 'error', { error: (err && err.message) });
       });
    }
  }, err => {
    this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'ACCEPT_CHAT', `acceptChat acceptchat ERROR | fid=${fid}`, 'error', { error: (err && err.message) });
  });
  return false;
}
endChat(){
  console.log('[endChat] ▶ START | UserId:', this.UserId, '| msgType:', this.msgType, '| sessionid:', sessionStorage.getItem('sessionid'), '| customeradmin:', sessionStorage.getItem('customeradmin'));
  $('.confirmmodel').hide();
  $('#idlemodel').hide();
  if(sessionStorage.getItem('sessionid')){
    const currentSessionId = sessionStorage.getItem('sessionid');
    console.log('[endChat] sessionid exists → calling message/endchat/', currentSessionId);
    this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'END_CHAT', `endChat message/endchat START | sessionId=${currentSessionId}`, 'start', { sessionId: currentSessionId });
    this._api.getTypeRequest('message/endchat/'+currentSessionId).subscribe((res:any) => {
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'END_CHAT', `endChat message/endchat SUCCESS | sessionId=${currentSessionId}`, 'success', { sessionId: currentSessionId });
      console.log('[endChat] endchat API response:', res);
      if(sessionStorage.getItem('customeradmin')){
        console.log('[endChat] Branch: customeradmin session → removing sessionid only, calling AfterChatend + sendmessage');
        sessionStorage.removeItem('sessionid');
        this.idle.stop();
        this.AfterChatend();
        this._api.postTypeRequest('sendmessage', '').subscribe((res: any) => {(res)});
      } else {
        console.log('[endChat] Branch: regular session → clearing all sessionStorage, fetching customeradminsession for UserId:', this.UserId);
        sessionStorage.clear();
        this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `endChat customeradminsession START | userId=${this.UserId}`, 'start');
        this._api.getTypeRequest('user/customeradminsession/'+this.UserId+'/0').subscribe((res: any) => {
          this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `endChat customeradminsession SUCCESS | userId=${this.UserId}`, 'success');
          console.log('[endChat] customeradminsession response:', res);
          try {
            var settingsVal = this._api.decrypt(res.settings)[0];
            var openTime = this.isOpen(settingsVal.starttime, settingsVal.endtime, settingsVal.timezone);
            var openDay = this.isOpenDay(settingsVal.offdays, settingsVal.timezone);
            console.log('[endChat] settingsVal:', settingsVal, '| openTime:', openTime, '| openDay (is off-day):', openDay);
            console.log('[endChat] Chat is open → storing session data for next session');
            this._auth.setDataInLocalStorage('userData', res.data);  
            this._auth.setDataInLocalStorage('token', res.token); 
            var usrType = this.msgType == 0?'Admin':'User'; 
            console.log('[endChat] userType stored as:', usrType);
            this._auth.setDataInLocalStorage('userType', usrType);    
            this._auth.setDataInLocalStorage('timezone', this._api.encryptString(settingsVal.timezone)); 
            console.log('[endChat] Calling AfterChatend + sendmessage (unconditional)');
            this.AfterChatend();
            this._api.postTypeRequest('sendmessage', '').subscribe((res: any) => {(res)});
          } catch(e) {
            console.error('[endChat] Failed to decrypt res.settings:', e.message, '| raw res:', res);
            console.warn('[endChat] Calling AfterChatend despite decrypt error');
            this.AfterChatend();
            this._api.postTypeRequest('sendmessage', '').subscribe((res: any) => {(res)});
          }
        }, err => {
          this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'GET_CUSTOMER_ADMIN_SESSION', `endChat customeradminsession ERROR | userId=${this.UserId}`, 'error', { error: (err && err.message) });
          this.AfterChatend();
        });
      }
    }, err => {
      this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'END_CHAT', `endChat message/endchat ERROR | sessionId=${currentSessionId}`, 'error', { error: (err && err.message) });
    });
  } else {
    console.warn('[endChat] No sessionid in sessionStorage — endchat skipped entirely');
  }
  return false;
}
endalready(){
  $('.alreadymodel').hide();
}
endChatConfirm(){
  $('.confirmmodel').show();
}
confirmno(){
  $('.confirmmodel').hide();
} 
dismissChat(id,fid){
  var divLen = $('.chatreqlen:visible').length;
  $('#chat'+id+fid).hide();
  if(divLen == 1)
    $('.main').hide();
  return false;
}
logout(){
  this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'USER_LOGOUT', `logout START | userId=${this.UserId}`, 'start');
  this._auth.clearStorage()
  this._api.getTypeRequest('user/logout/'+this.UserId).subscribe(res => {
    this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'USER_LOGOUT', `logout SUCCESS | userId=${this.UserId}`, 'success');
  }, err => {
    this._log.log(this.UserId, this.msgType == 0 ? 'Admin' : 'Customer', 'USER_LOGOUT', `logout ERROR | userId=${this.UserId}`, 'error', { error: (err && err.message) });
  });
  this._router.navigate(['/login']);
}
trimedCkEditorText(str) {
  let contentStr = str;
  contentStr = this.trimedCkEditorTextAt(contentStr, true);
  contentStr = this.trimedCkEditorTextAt(contentStr, false);
  return contentStr;
}
trimedCkEditorTextAt(contentStr, startOfText) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(contentStr, "text/html")
  while(doc.body.children.length) {
      const index = startOfText ? 0 : doc.body.children.length - 1; 
      const child = doc.body.children[index];    
      if(child.textContent.replace(/\s/g, '').length) {
          while(child.children.length) {
              const index = startOfText ? 0 : child.children.length - 1; 
              const grandechild = child.children[index];
              if(grandechild.localName == 'br') grandechild.remove();
              else break;
          }
          const childTextArray = child.innerHTML.split(' ');
          while(childTextArray.length) {
              const index = startOfText ? 0 : childTextArray.length - 1; 
              if(childTextArray[index] == '&nbsp;') childTextArray.splice(index, 1);
              else break;
          }
          child.innerHTML = childTextArray.join(' ');
          break;
      } else {
          child.remove();
      }
  }
  return doc.body.innerHTML;
}
isValidHttpUrl(string) {
  try {
    const url = new URL(string);
    return url.protocol == 'http:' || url.protocol == 'https:';
  } catch (err) {
    return false;
  }
}
  gethttpURL(txt){
    var urls = txt.match(/\b(http|https)?(:\/\/)?(\S*)\.(\w{2,4})\b/ig);
    var newStr = txt;
    if(urls && urls.length > 0){
      var txtURL = [];
      for (var i = 0, il = urls.length; i < il; i++) {
          txtURL.push(urls[i]);
      }
      (txtURL);
      for(var j = 0;j < txtURL.length; j++){
        var url = this.isValidHttpUrl(txtURL[j])?txtURL[j]:'http://'+txtURL[j];
        newStr = newStr.replace(txtURL[j], '<a href="'+url+'" target="_blank" rel="noopener noreferrer" class="chat-link">'+txtURL[j]+'</a>');
      }
    }
    return newStr;
  }
sendMessageClick() {
  if (this.selectedFile) {
    this.uploadAndSendMessage();
    return;
  }
  var message = this.message;
  message = this.gethttpURL(message);
  message = this.trimedCkEditorText(message);
  var repMes = this.repMessage ? this.repMessage : '';
  if (message) {
    var adminid = '';
    if (this.msgType == 1 && !sessionStorage.getItem('sessionid'))
      adminid = this.adminId == '' ? '' : this.adminId;
    var conid = sessionStorage.getItem('sessionid') ? sessionStorage.getItem('sessionid') : 0;
    var messagePacket = {
      message: message,
      fromUserId: this.UserId,
      toUserId: this.FrndId,
      adminid: adminid,
      con_id: conid,
      cid: this.msgType == 1 ? this.UserId : this.FrndId,
      date: this.timzoneTime(),
      type: this.msgType
    };
    this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'SEND_MESSAGE',
      `sendMessageClick START | fromUserId=${this.UserId} toUserId=${this.FrndId} conId=${conid} type=${this.msgType}`,
      'start', { fromUserId: this.UserId, toUserId: this.FrndId, conId: conid, type: this.msgType });
    this.isSending = true;
    this.sendRetryCount = 0;
    this.attemptSendMessage(messagePacket);
    message = '';
    this.message = '';
    this.repMessage ? this.closereplymessage() : '';
  }
}
private attemptSendMessage(messagePacket: any) {
  this._api.postTypeRequest('message/insert', { data: this._api.encryptArray(messagePacket) }).subscribe(async (res: any) => {
        this.sendRetryCount = 0;
        if(this._auth.getUsertype()!='User'){   
          await this.UpdateUnread(this.FrndId);
        }
        if (res.already && res.already == 1) {
          this.isSending = false;
          this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'SEND_MESSAGE',
            `message/insert: already=1 (session already open) | fromUserId=${this.UserId}`,
            'error', { fromUserId: this.UserId, toUserId: this.FrndId });
          if (this._auth.getUsertype() == 'User') {
            await this.getMessages(this.UserId);
            this.endsess = 1;
            this.message = '';
            let Connected;
            if (this.convertbtn_id && this.adminnotconnect === 0) { Connected = true; } else { Connected = false; }
            var SessUserData2 = this._auth.getUserDetails();
            let userData2 = SessUserData2[0];
            userData2.message = messagePacket.message;
            this._api.postTypeRequest('AlertUser', { userid: this.UserId, connected: Connected, userdata: userData2 }).subscribe((res: any) => {});
            this._api.postThirdparyurl(this._api.notifyTrigger, '').subscribe((res: any) => {});
          } else {
            $('.alreadymodel').show();
          }
        } else {
          this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'SEND_MESSAGE',
            `message/insert: success | fromUserId=${this.UserId} toUserId=${this.FrndId} conId=${messagePacket.con_id}`,
            'success', { fromUserId: this.UserId, toUserId: this.FrndId, conId: messagePacket.con_id });
          if (this._auth.getUsertype() == 'User') {
            let Connected;
            if (this.convertbtn_id && this.adminnotconnect === 0) { Connected = true; } else { Connected = false; }
            var SessUserData3 = this._auth.getUserDetails();
            let userData3 = SessUserData3[0];
            userData3.message = messagePacket.message;
            this._api.postTypeRequest('AlertUser', { userid: this.UserId, connected: Connected, userdata: userData3 }).subscribe((res: any) => {});
          } else {
            this._api.postTypeRequest('sendmessage', messagePacket).subscribe((res: any) => {});
          }
          await this.getMessages(this.UserId);
          if (this.FrndId && !sessionStorage.getItem('sessionid') && this.msgType == 0) {
            var data2 = this._api.decrypt(res.data);
            this._auth.setDataInLocalStorage('sessionid', data2[0].con_id);
            this.idle.watch();
            this.timedOut = false;
          }
          this.endsess = 1;
          this.message = '';
          this.isSending = false;
          this._api.postThirdparyurl(this._api.notifyTrigger, '').subscribe((res: any) => {});
        }
      }, (err) => {
        if (this.sendRetryCount < this.MAX_SEND_RETRIES) {
          this.sendRetryCount++;
          this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'SEND_MESSAGE',
            `message/insert HTTP error — retrying (${this.sendRetryCount}/${this.MAX_SEND_RETRIES}) | fromUserId=${this.UserId}`,
            'error', { error: (err && err.message) });
          setTimeout(() => this.attemptSendMessage(messagePacket), 2000);
        } else {
          this.isSending = false;
          this.sendRetryCount = 0;
          this.message = '';
          this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'SEND_MESSAGE',
            `message/insert HTTP error — final failure | fromUserId=${this.UserId}`, 'error', { error: (err && err.message) });
          Swal.fire(
            'Message could not be sent',
            'Something went wrong. Please try again.',
            'error'
          );
        }
      });
}
UpdateUnread(touserid){
  return new Promise(resolve=>{
  this._api.getTypeRequest('message/UpdateUnreadmsg/'+touserid).subscribe((res:any) => {
   resolve(res)
  },err=>{
    resolve(err)
  });
})
}
getMessageWidth() {
  if (this._auth.getUsertype() === 'User') {
    return 'user';
  } else {
    return 'admin';
  }
}
selectFriendToChat (data) {
  this.selectedFriend = data;
  this.selectedFriendName = data.firstname;
  this.selectedFriendId = data.id;
  this.getMessages(this.UserId,data.id);
}

refreshFriendData() {
  if (this.FrndId) {
    this._api.getTypeRequest('message/users/' + this.FrndId).subscribe((res: any) => {
      const data = this._api.decrypt(res.data);
      if (data && data.length > 0) {
        this.selectedFriend = data[0];
        this.selectedFriendName = data[0].firstname;
        this.selectedFriendId = data[0].id;
      }
    });
  }
}
todayString(mdate,disp){
  var today = new Date();
  var mesdate = new Date(mdate);
  var msdate = new Date(mdate).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric'}).replace(/ /g, '/');
  return today.toDateString() == mesdate.toDateString() && disp == 'chat'?'Today':msdate;
}
timzoneTime(){
  const givDate = moments().tz(this._auth.getTimezone());
  var mesdate = givDate.format('YYYY-MM-DD H:mm:ss');
  return mesdate;
}
alignMessage(fromUserId) {
  if(this.msgType == 1)
    return fromUserId == 'Admin' ? true : false;
  else
   return fromUserId == 'Admin' ? false : true;
}
datewiseMessages(data){
  var messArray = [];
    var i=0;
    data.forEach(obj => {
      var dateStr = obj.mdate.split('T')[0];
      //messArray[i] = {date:dateStr,data:obj};
      if(!messArray[i]){
        messArray[i] =[];
        messArray[i]['date'] = dateStr;
        messArray[i]['data'] = [];
        messArray[i]['data'].push(obj);
      } else if(messArray[i]['date'] == dateStr) {
        messArray[i]['data'].push(obj);
      } else {
        i++;
        messArray[i] =[];
        messArray[i]['date'] = dateStr;
        messArray[i]['data'] = [];
        messArray[i]['data'].push(obj);
      }
    });
    this.scrollToBottom();
    return messArray;
}
  async getMessages(userId, frdId = null) {
    this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'GET_MESSAGES',
      `getMessages START | userId=${userId} FrndId=${this.FrndId} msgType=${this.msgType}`,
      'start', { userId, FrndId: this.FrndId, msgType: this.msgType });
    userId = this.msgType == 0 ? this.FrndId : this.UserId;
    if (!this.FrndId) {
      await this.getFrndId(this.UserId);
    }
    this.getMessagesRetryCount = 0;
    this.attemptGetMessages(userId);
  }
  private attemptGetMessages(userId: any) {
    if(this.msgType == 0){
      if(this.FrndId !=undefined && this.FrndId !='undefined'){
        this._log.log(this.UserId, 'Admin', 'MESSAGES_READ', `getMessages messagesread START | userId=${this.UserId} FrndId=${this.FrndId}`, 'start');
        this._api.getTypeRequest('message/messagesread/'+this.UserId+'/'+this.FrndId).subscribe((res:any) => {
          this._log.log(this.UserId, 'Admin', 'MESSAGES_READ', `getMessages messagesread SUCCESS | userId=${this.UserId} FrndId=${this.FrndId}`, 'success');
          
          this._log.log(this.UserId, 'Admin', 'GET_MESSAGES', `getMessages API message/messages START | userId=${userId} FrndId=${this.FrndId}`, 'start');
          this._api.getTypeRequest('message/messages/'+userId+'/'+this.FrndId).subscribe((res:any) => {
            var data = this._api.decrypt(res.data);
            this._log.log(this.UserId, 'Admin', 'GET_MESSAGES', `getMessages API message/messages SUCCESS | count=${data ? data.length : 0}`, 'success');
            if(data.length){
              if(data[data.length-1].con_id == 0 || data[data.length-1].toUserId == 0){
                this.chathide = 0;
              }
              this.adminnotconnect = 0
              if(data[data.length-1].toUserId == 0 && data[data.length-1].endsess == 0){
                this.adminnotconnect = 1
              }
            }
            this.messages = this.datewiseMessages(data);
            if(res.datacnt && res.datacnt[0].unread > 0) {
              this._api.postTypeRequest('sendmessage', '').subscribe((res: any) => {(res)});
            }
          }, err => {
            this.handleGetMessagesError(userId, err);
          });
        }, err => {
          this._log.log(this.UserId, 'Admin', 'MESSAGES_READ', `getMessages messagesread ERROR`, 'error', { error: (err && err.message) });
        });
      }else{
        Swal.fire('Info!',"Unable to load messages","info")
      }
    } else {
      if(this.FrndId !=undefined && this.FrndId !='undefined'){
        this._log.log(this.UserId, 'Customer', 'GET_MESSAGES', `getMessages API message/messages START | userId=${userId} FrndId=${this.FrndId}`, 'start');
        this._api.getTypeRequest('message/messages/'+userId+'/'+this.FrndId).subscribe((res:any) => {
          var data = this._api.decrypt(res.data);
          this._log.log(this.UserId, 'Customer', 'GET_MESSAGES', `getMessages API message/messages SUCCESS | count=${data ? data.length : 0}`, 'success');
          if(data.length){
            if(data[data.length-1].con_id == 0 || data[data.length-1].toUserId == 0){
              this.chathide = 0;
            }
            this.adminnotconnect = 0
            if(data[data.length-1].toUserId == 0 && data[data.length-1].endsess == 0){
              this.adminnotconnect = 1
            }
          }
          this.messages = this.datewiseMessages(data);
          if(res.datacnt && res.datacnt[0].unread > 0) {
            this._api.postTypeRequest('sendmessage', '').subscribe((res: any) => {(res)});
          }
          this.scrollToBottom();
        }, err => {
          this.handleGetMessagesError(userId, err);
        });
      }else{
        Swal.fire('Info!',"Unable to load messages","info")
      }
    }
  }
  private handleGetMessagesError(userId: any, err: any) {
    if (this.getMessagesRetryCount < this.MAX_GET_RETRIES) {
      this.getMessagesRetryCount++;
      this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'GET_MESSAGES',
        `getMessages API message/messages ERROR — retrying (${this.getMessagesRetryCount}/${this.MAX_GET_RETRIES})`,
        'error', { error: (err && err.message) });
      setTimeout(() => this.attemptGetMessages(userId), 3000);
    } else {
      this.getMessagesRetryCount = 0;
      this._log.log(this.UserId, this.msgType == 1 ? 'Customer' : 'Admin', 'GET_MESSAGES',
        `getMessages API message/messages ERROR — final failure`, 'error', { error: (err && err.message) });
      console.error('[getMessages] Failed after retry — will reload on next event');
    }
  }

  onScroll(event: any) {
    const element = event.target;
    const threshold = 300; 
    const currentPos = element.scrollHeight - element.scrollTop - element.clientHeight;
    
    this.showScrollToBottom = currentPos > threshold;
  }

  scrollToBottomClicked() {
    this.scrollToBottom();
  }

  toggleChatSearch() {
    this.isChatSearchVisible = !this.isChatSearchVisible;
    if (!this.isChatSearchVisible) {
      this.chatSearchQuery = '';
    }
  }

  clearChatSearch() {
    this.chatSearchQuery = '';
  }

  get filteredMessages() {
    if (!this.chatSearchQuery || this.chatSearchQuery.trim() === '') {
      return this.messages;
    }
    const query = this.chatSearchQuery.toLowerCase();
    return (this.messages || []).map(day => {
      const filteredData = day.data.filter(msg => 
        (msg.message && msg.message.toLowerCase().includes(query)) ||
        (msg.firstname && msg.firstname.toLowerCase().includes(query))
      );
      return { ...day, data: filteredData };
    }).filter(day => day.data.length > 0);
  }

  getInitials(firstName, lastName) {
    if(!firstName && lastName){
      return lastName[0].toUpperCase()
    }else if(!lastName && firstName){
      return firstName[0].toUpperCase()
    }else if (!firstName ||!lastName) {
      return 'CBL'
    }else{
      return (firstName[0] + lastName[0]).toUpperCase();
    }
  }
  userendChat() {
    this.endChat();
    $('#confirmIdel').hide();
  }
  userStay() {
    $('#confirmIdel').hide();
  }
  scrollToBottom() {
    this.zone.runOutsideAngular(() => {
      const messageThread = document.getElementById('users-conversation');
      if (messageThread) {
        // Pass 1: Immediate attempt
        messageThread.scrollTo({ top: messageThread.scrollHeight, behavior: 'smooth' });

        // Pass 2: Short delay
        setTimeout(() => {
          messageThread.scrollTo({ top: messageThread.scrollHeight, behavior: 'smooth' });
        }, 150);

        // Pass 3: Asset load buffer
        setTimeout(() => {
          messageThread.scrollTo({ top: messageThread.scrollHeight, behavior: 'smooth' });
        }, 400);

        // Pass 4: Final safety check
        setTimeout(() => {
          messageThread.scrollTo({ top: messageThread.scrollHeight, behavior: 'smooth' });
        }, 800);
      }
    });

    // Handle isSending state inside Angular zone if needed
    this.zone.run(() => {
      setTimeout(() => {
        this.isSending = false;
      }, 100);
    });
  }
  closereplymessage() {
    var i = document.querySelector(".replyCard");
    if (i) i.classList.remove("show");
    this.repMessage = '';
  }

    assignCustomer(friendId) {
    if (!friendId) return;
    this.pendingActionFriendId = friendId;
    $('.claimModel').show();
  }

  closeClaimModal() {
    $('.claimModel').hide();
    this.pendingActionFriendId = null;
  }

  confirmAssignCustomer() {
    if (!this.pendingActionFriendId) return;

    this.spinner.show();
    this._api.postTypeRequest('messages/assignCustomer', {
      customer_id: this.pendingActionFriendId,
      admin_id: this.UserId
    }).subscribe((res: any) => {
      this.spinner.hide();
      this.closeClaimModal();
      if (res.status == 1) {
        if (this.selectedFriend && this.selectedFriend.id == this.pendingActionFriendId) {
          this.selectedFriend.assigned_admin_id = this.UserId;
        }
        Swal.fire('Claimed!', 'Customer has been assigned to you.', 'success');
      } else {
        Swal.fire('Error', 'Failed to assign customer.', 'error');
      }
    }, err => {
      this.spinner.hide();
      this.closeClaimModal();
      Swal.fire('Error', 'Failed to assign customer.', 'error');
    });
  }

  unassignCustomer(friendId) {
    if (!friendId) return;
    this.pendingActionFriendId = friendId;
    $('.unassignModel').show();
  }

  closeUnassignModal() {
    $('.unassignModel').hide();
    this.pendingActionFriendId = null;
  }

  confirmUnassignCustomer() {
    if (!this.pendingActionFriendId) return;

    this.spinner.show();
    this._api.postTypeRequest('messages/unassignCustomer', { customer_id: this.pendingActionFriendId }).subscribe((res: any) => {
      this.spinner.hide();
      this.closeUnassignModal();
      if (res.status == 1) {
        if (this.selectedFriend && this.selectedFriend.id == this.pendingActionFriendId) {
          this.selectedFriend.assigned_admin_id = null;
        }
        Swal.fire('Unassigned!', 'Customer is now unassigned.', 'success');
      } else {
        Swal.fire('Error', 'Failed to unassign customer.', 'error');
      }
    }, err => {
      this.spinner.hide();
      this.closeUnassignModal();
      Swal.fire('Error', 'Failed to unassign customer.', 'error');
    });
  }

  // --- FILE UPLOAD METHODS ---
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    // Validation: 5MB
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire('Error', 'File size should be less than or equal to 5MB', 'error');
      event.target.value = '';
      return;
    }

    // Validation: Types
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      Swal.fire('Error', 'Only .jpeg, .jpg, .png and .pdf files are allowed', 'error');
      event.target.value = '';
      return;
    }

    this.selectedFile = file;
    this.message = ''; // Clear text message when file is selected
  }

  clearSelectedFile() {
    this.selectedFile = null;
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  uploadAndSendMessage() {
    if (!this.selectedFile) return;

    this.isSending = true;
    this.spinner.show();

    const SessUserData = this._auth.getUserDetails();
    const sessUser = SessUserData ? SessUserData[0] : {};
    
    // Extract CID and LID from session user data
    // CID is likely the external Customer ID (userid)
    // LID is the Loan ID
    const CID = sessUser.userid || sessUser.CID || this.UserId || '0';
    const LID = sessUser.loanid || sessUser.LID || '0';

    const metadata = {
      LID: LID,
      CID: CID
    };

    const fileName = this.selectedFile.name;
    const conid = sessionStorage.getItem('sessionid') ? sessionStorage.getItem('sessionid') : 0;

    this._log.log(this.UserId, 'Customer', 'FILE_UPLOAD', `chatAppUpload START | filename=${fileName} CID=${CID}`, 'start', { fileName, CID });
    this._api.chatAppUpload(this.selectedFile, CID, metadata).subscribe(
      (res: any) => {
        // The new API returns { success: true, msg: "..." }
        if (res.success) {
          this._log.log(this.UserId, 'Customer', 'FILE_UPLOAD', `chatAppUpload SUCCESS | filename=${fileName}`, 'success', { fileName });
          
          this._log.log(this.UserId, 'Customer', 'FILE_NOTIFICATION', `insertFileNotification START | filename=${fileName} conid=${conid}`, 'start', { fileName, conid });
          // Call internal API to insert a notification message into the chat
          this._api.insertFileNotification(this.UserId, this.FrndId, conid, fileName, res.Data).subscribe(
            () => {
              this._log.log(this.UserId, 'Customer', 'FILE_NOTIFICATION', `insertFileNotification SUCCESS | filename=${fileName}`, 'success', { fileName });
              this.spinner.hide();
              this.clearSelectedFile();
              this.message = '';
              this.getMessages(this.UserId);
              this.scrollToBottom();
              
              if (this._auth.getUsertype() == 'User') {
                const userData = sessUser;
                userData.message = "Sent an attachment";
                this._api.postTypeRequest('AlertUser', { userid: this.UserId, connected: true, userdata: userData }).subscribe(() => {});
              }
            },
            err => {
              this._log.log(this.UserId, 'Customer', 'FILE_NOTIFICATION', `insertFileNotification ERROR | filename=${fileName}`, 'error', { fileName, error: (err && err.message) });
              this.spinner.hide();
              console.error('Failed to insert file notification:', err);
              // We still want to refresh messages as the upload was successful
              this.getMessages(this.UserId);
            }
          );
        } else {
          this._log.log(this.UserId, 'Customer', 'FILE_UPLOAD', `chatAppUpload returned success=false | filename=${fileName}`, 'error', { fileName, msg: res.msg });
          this.spinner.hide();
          Swal.fire('Error', res.msg || 'File upload failed', 'error');
        }
        this.isSending = false;
      },
      err => {
        this._log.log(this.UserId, 'Customer', 'FILE_UPLOAD', `chatAppUpload ERROR | filename=${fileName}`, 'error', { fileName, error: (err && err.message) });
        this.spinner.hide();
        this.isSending = false;
        Swal.fire('Error', 'An error occurred during file upload', 'error');
      }
    );
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const uploadNotification = target.closest('.chat-attachment-notification');
    
    if (uploadNotification) {
      const docDataStr = uploadNotification.getAttribute('data-doc');
      if (docDataStr) {
        try {
          const docData = JSON.parse(decodeURIComponent(docDataStr));
          window.parent.postMessage({
            "Method": 'DocumentView',
             Data: docData
          }, '*');
        } catch (e) {
          console.error('Error parsing document data:', e);
        }
      }
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}